import { render, staticRenderFns } from "./TypeErrorElem.vue?vue&type=template&id=501d0260&"
import script from "./TypeErrorElem.vue?vue&type=script&lang=ts&"
export * from "./TypeErrorElem.vue?vue&type=script&lang=ts&"
import style0 from "./TypeErrorElem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports